import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { getPresentationOptions } from '@/module/Author/Presentation';
import { PresentationEdit } from '@/module/Author/Presentation/PresentationEdit';

export const Route = createFileRoute('/_auth/author/_author/presentation/_presentation/$presentationId/_layout/edit')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.edit' },
  },
});

function RouteComponent() {
  const { presentationId } = Route.useParams();
  const { data: presentation } = useSuspenseQuery(getPresentationOptions(presentationId));

  return <PresentationEdit presentation={presentation} />;
}
